// Port of api/fuel/app/classes/model/log/user/collection/status.php
import Model from 'offline/stream/model/base'
import Constants from 'offline/constants'

export default Model.extend({
	table: 'log_user_collection_status',
	prefix: 'log',
	key: 'log_id',
	fields: {
		log_id: Model.SCHEMA_KEY,
		log_date: Model.SCHEMA_DATE_CREATE,
		user_id: Model.SCHEMA_NUMBER,
		game_id: Model.SCHEMA_NUMBER,
		game_version_id: Model.SCHEMA_NUMBER,
		collection_id: Model.SCHEMA_NUMBER,
		log_context: Model.SCHEMA_NUMBER,
		log_initial_sync: Model.SCHEMA_NUMBER,
		log_status: Model.SCHEMA_NUMBER
	},
	methods: {
		get_type: function() { return Constants.LOG_TYPE_USER_COLLECTION_STATUS },
		to_array: function() {
			return {
				id: +this.get_id(),
				date: +this.get_date(),
				type: +this.get_type(),
				context: +this.get_context(),
				user: +this.get_user_id(),
				game: +this.get_game_id(),
				version: +this.get_game_version_id(),
				collection: +this.get_collection_id(),
				status: +this.get_status()
			}
		}
	}
})
